import CryptoJS from "crypto-js";

// DO NOT use `.enc.Hex.parse()` — match backend's utf-8 treatment
const ENCRYPTION_KEY = CryptoJS.enc.Utf8.parse("abcdefghijklmnopqrstuvwx12345678");
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");

export const encryptKey = (text: string): string => {
  try {
    const encrypted = CryptoJS.AES.encrypt(text, ENCRYPTION_KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Return Base64 string to match Node.js output
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  } catch (error) {
    console.error("Encryption Error:", error);
    throw error;
  }
};